module.exports = __webpack_public_path__ + "static/media/stop-pickup.81f3a7b9.svg";